import { render, staticRenderFns } from "./remove_wrestler_payment_plan.vue?vue&type=template&id=0b866e36&"
import script from "./remove_wrestler_payment_plan.vue?vue&type=script&lang=js&"
export * from "./remove_wrestler_payment_plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports